import z from 'zod';

export const RsvLrvInfo = z.object({
  showReportingAu: z.boolean(),
  showReportingAl: z.boolean(),
});

export type RsvLrvInfo = z.infer<typeof RsvLrvInfo>;
